import React from "react"
import { ButtonProps } from "@material-ui/core/Button"
import FormButton from "./FormButton"

export default function FormSecondaryButton({ ...rest }: ButtonProps) {
    return <FormButton {...rest} color="secondary" variant="contained" />
}
